import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumLabel',
   standalone: true,
})
export class EnumLabelPipe implements PipeTransform {

transform(value: number | string | null | undefined, enumObj: any): string {
    if (value === null || value === undefined) return '';

    const key = enumObj[value]; 
    if (!key) return String(value);

    return key.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

}
